import {defineStore} from 'pinia';
import {changePassword, checkEmail, createNewUser, login, lostPassword, resetPassword} from "@/scripts/api/auth";
import {useToast} from "vue-toastification";

const toast = useToast();

export const useAuth = defineStore('auth', {
    actions: {
        async createUser(
            email: string,
            password: string,
            timezoneName: string
        ) {
            try {
                await createNewUser(
                    email,
                    password,
                    timezoneName
                )

                toast.success("Аккаунт успешно создан");

                return true
            } catch (error: any) {
                toast.error(error.response?.data.message);

                return false;
            }
        },

        async changePassword(
            currentPassword: string,
            newPassword: string,
            newPasswordConfirmation: string,
        ) {
            try {
                await changePassword(
                    currentPassword,
                    newPassword,
                    newPasswordConfirmation,
                )

                toast.success("Новый пароль успешно сохранен");
            } catch (error: any) {
                toast.error(error.response?.data.message);
            }
        },

        async login(
            email: string,
            password: string,
        ) {
            try {
                await login(
                    email,
                    password,
                )

                toast.success("Вход успешно выполнен");

                return true;
            } catch (error: any) {
                toast.error(error.response?.data.message);

                return false;
            }
        },

        async lostPassword(
            email: string,
        ) {
            try {
                await lostPassword(
                    email
                )

                toast.success("Ссылка для восстановления отправлена на почту");

                return true;
            } catch (error: any) {
                toast.error(error.response?.data.message);

                return false;
            }
        },

        async resetPassword(
            email: string,
            token: string,
            password: string,
            passwordConfirmation: string,
        ) {
            try {
                await resetPassword(
                    email,
                    token,
                    password,
                    passwordConfirmation
                )

                toast.success("Пароль успешно изменен");

                return true;
            } catch (error: any) {
                toast.error(error.response?.data.message);

                return false;
            }
        },

        async isEmailExist(email: string) {
            try {
                await checkEmail(
                    email,
                )

                return true;
            } catch (error: any) {

                return false;
            }
        }
    }
});
